var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import * as EquityApi from "../modules/equity/api";
import * as DataTablesApi from "../modules/datatables/api";
import DataTable, { TimePeriodTotals } from "../components/DataTable";
// technically impossible
var noRowsToDisplay = React.createElement(React.Fragment, null);
var tableHeader = (React.createElement("div", null,
    React.createElement("i", { className: "fas fa-chart-pie fa-fw text-muted mr-2" }),
    "Equity funds received"));
export default function EquityDataTable() {
    var _this = this;
    var initializeTable = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, EquityApi.fetchEquity()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var commitCellUpdate = function (newValue, rowId, cellId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, EquityApi.updateEquity(cellId, newValue)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onCellCopyForward = function (newValue, rowId, cellId, month, resourceType, resourceId, toMonth) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(resourceId !== undefined && toMonth !== undefined)) return [3 /*break*/, 2];
                    return [4 /*yield*/, DataTablesApi.copyForward(resourceId, 'Company', 'equity', newValue, month.toString(), 'value', toMonth.toString())];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return React.createElement(DataTable, { initializeTable: initializeTable, columnsHeader: '', tableHeader: tableHeader, commitCellUpdate: commitCellUpdate, onCellCopyForward: onCellCopyForward, noRowsToDisplay: noRowsToDisplay, cellHint: '\u00A3', timePeriodTotals: TimePeriodTotals.Yearly, headerMonthFormat: 'MMM' });
}
